/* eslint-disable max-classes-per-file */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AmplifyAuthenticatorModule } from "@aws-amplify/ui-angular";
import { NgxSmarterplanCoreModule } from "@smarterplan/ngx-smarterplan-core";
import { AuthComponent } from "./auth.component";

const routes: Routes = [
    {
        path: "auth",
        component: AuthComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
class AuthRoutingModule { }

@NgModule({
    declarations: [AuthComponent],
    imports: [
        CommonModule,
        AuthRoutingModule,
        TranslateModule,
        AmplifyAuthenticatorModule,
        NgxSmarterplanCoreModule,
    ],
})
export class AuthModule { }
